






























































import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import address from "../../model/citys.json";
@Component({
  components: {}
})
export default class Address extends Vue {
  @Prop()
  default;
  form = {
    province: "",
    // 市
    city: "",
    // 区
    district: "",
    //详细地址
    detail: ""
  };

  @Prop({ default: "all" })  // 支持 all, province-city 2种
  mode;

  @Prop({ default: "120px" })
  compWidth;

  addressData: any = [];
  //  市数据
  cityData: any = [];
  // 区数据
  areaData: any = [];
  created() {
    // 省份数据初始化
    this.addressData = address;
    this.form = this.default;
    if (this.form.province != "") {
      console.log(this.form);
      const cityData = this.addressData.filter(
        item => item.name == this.form.province
      );
      if (cityData.length) {
        this.cityData = cityData[0].children;

        const areaData = this.cityData.filter(
          item => item.name == this.form.city
        );
        if (areaData.length) {
          this.areaData = areaData[0].children;
        }
      }
    }
  }
  // 省份更改
  changePro(e) {
    // 从省中过滤出市的数据
    this.cityData = this.addressData.filter(item => {
      return item.province == e;
    })[0].city;
    // 省发生改变的时候 清空输入框市区街道的内容

    this.form.district = "";
    this.form.city = this.cityData[0].name;
    // 省发生更改时 该表空区街道数据的内容
    this.areaData = this.cityData[0].county;
    this.form.district = this.areaData[0];
    this.validate() && this.$emit("update", this.form);
  }
  // 市更改
  changeCity(e) {
    // 获取到区的数据
    this.areaData = this.cityData.filter(item => item.name == e)[0].county;
    // 清空数据后面对应数组的数据
    this.form.district = this.areaData[0];
    console.log("update city");
    this.validate() && this.$emit("update", this.form);
  }
  // 区更改
  changeArea(e) {
    const temp = this.areaData.filter(item => item.name == e);
    this.validate() && this.$emit("update", this.form);
    // 获取到区的code码
    // this.form.regionalNumber = temp[0].code;
    // // 获取到街道的数据
    // this.jdData = this.areaData.filter(item => item.name == e)[0].children;
  }
  changeDetail(e) {
    //
    this.validate() && this.$emit("updateData", this.form);
  }
  validate() {
    if (
      (!this.isProvinceVisible || this.form.province.length > 0) &&
      (!this.isCityVisible || this.form.city.length > 0) &&
      (!this.isDistrictVisible || this.form.district.length > 0) &&
      (!this.isDetailVisible || this.form.detail.length > 0)
    ) {
      return true;
    }
    return false;
  }

  get isProvinceVisible() {
    console.log(this._getModeInfo());
    console.log("isProvinceVisible: " + this._getModeInfo()[this.mode].includes("province"));
    return this._getModeInfo()[this.mode].includes("province");
  }

  get isCityVisible() {
    return this._getModeInfo()[this.mode].includes("city");
  }

  get isDistrictVisible() {
    return this._getModeInfo()[this.mode].includes("district");
  }

  get isDetailVisible() {
    return this._getModeInfo()[this.mode].includes("detail");
  }

  _getModeInfo() {
    return {
      "all": ["province", "city", "district", "detail"],
      "province-city": ["province", "city"]
    };
  }
}
